"use client"

import { MessageSquare, User, Zap } from "lucide-react"

type BottomNavProps = {
  activeScreen: string
  setActiveScreen: (screen: string) => void
}

export function BottomNav({ activeScreen, setActiveScreen }: BottomNavProps) {
  const navItems = [
    { id: "analyze", icon: MessageSquare, label: "Analyze" },
    { id: "profile", icon: User, label: "Account" },
    { id: "upgrade", icon: Zap, label: "Premium" },
  ]

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 glass rounded-full h-16 flex items-center justify-around px-6 z-50 w-[90%] max-w-md shadow-xl shadow-black/20">
      {navItems.map((item) => {
        const isActive = activeScreen === item.id
        return (
          <button
            key={item.id}
            className="flex flex-col items-center justify-center w-1/3 h-full transition-all relative"
            onClick={() => setActiveScreen(item.id)}
          >
            <item.icon className={`h-5 w-5 ${isActive ? "text-rose-400" : "text-zinc-400"}`} />
            <span className={`text-xs mt-1 ${isActive ? "text-rose-400" : "text-zinc-400"}`}>{item.label}</span>
          </button>
        )
      })}
    </div>
  )
}

